import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ContractBody from "components/CompaniesComponents/CompanyDetails/CompanyContracts/ContractBody";

const CompanyContracts = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Companies";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="companies" />
      <ContractBody />
    </main>
  );
};

export default CompanyContracts;
